import React, { useState, useEffect } from 'react';
import axios from "axios";
import {API_URL} from "../../App"



const WinrateGrid = ({ botInfo }) => {
  const [winrates, setWinrates] = useState(null);

  useEffect(() => {
    // Fetch the list of available metrics from the database
    const fetchWinrates = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/bot-winrates/${botInfo.bot.id}`);
        setWinrates(response.data);
      } catch (error) {
        //console.error("Failed to fetch winrates", error);
      }
    };
    fetchWinrates();
  }, []);

    // Display a message if no data is available
  if (!winrates) {
    return (
      <div className="p-6 space-y-8">
        <p>Loading data...</p>
      </div>
    );
  }
  if (winrates?.winrate_per_character.length == 0 || winrates?.winrate_per_stage.length == 0) {
    return (
      <div className="p-6 space-y-8">
        <p >No data.</p>
      </div>
    );
  }

  return (
    <div className="py-4 px-8 space-y-4">
      <h2 className="text-2xl font-bold pb-4 mb-4 text-center border-b border-gray-700">Winrate by Character</h2>
      {/* Winrate per Character */}
      <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-10 gap-2">
        {winrates.winrate_per_character.map(({ opponent_character, winrate }, index) => (
          <div
            key={index}
            className="flex flex-col items-center space-y-2"
          >
            <img
              src={`/icons/${opponent_character}_0.webp`}
              alt=""
              className="w-8 h-8 object-contain border rounded-full"
            />
            <span className="text-sm font-bold">
              {winrate.toFixed(0)}%
            </span>
          </div>
        ))}
      </div>

    {/* Winrate per Stage */}
    <h2 className="text-2xl font-bold pb-4 mb-4 text-center border-b border-gray-700">Winrate by Stage</h2>
      <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {winrates.winrate_per_stage.map(({ stage, winrate }, index) => (
          <div
            key={index}
            className="flex flex-col items-center space-y-2"
          >
            <img
              src={`/stages/STAGE_${stage}.webp`}
              alt=""
              className="w-16 h-16 border rounded-full"
            />
            <span className="text-sm font-bold">
              {winrate.toFixed(0)}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WinrateGrid;
